"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketIoEvent = void 0;
var SocketIoEvent;
(function (SocketIoEvent) {
    SocketIoEvent["connect"] = "connect";
    SocketIoEvent["reconnect"] = "reconnect";
    SocketIoEvent["disconnect"] = "disconnect";
    SocketIoEvent["error"] = "error";
    SocketIoEvent["connectError"] = "connect_error";
    SocketIoEvent["connectTimeout"] = "connect_timeout";
    SocketIoEvent["reconnectError"] = "reconnect_error";
    SocketIoEvent["reconnectFailed"] = "reconnect_failed";
})(SocketIoEvent || (exports.SocketIoEvent = SocketIoEvent = {}));
//# sourceMappingURL=SocketIoEvent.js.map